/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 其他模块路由
 */

const ExtractArticle = () => import('@/views/others/extractArticle.vue')
const CommonWords = () => import('@/views/others/commonWords.vue')
const FeedbackList = () => import('@/views/feedback/index.vue')
const FeedbackDetail = () => import('@/views/feedback/detail.vue')
/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/others',
    component: Layout,
    redirect: '/others/extract-article',
    meta: {
        title: '其他',
        icon: 'icon-others',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'extract-article',
            component: ExtractArticle,
            name: 'ExtractArticle',
            meta: {
                title: '文章测试'
            }
        },
        {
            path: 'common-word',
            component: CommonWords,
            name: 'CommonWords',
            meta: {
                title: '常用语'
            }
        },
        {
            path: 'feedback-list',
            component: FeedbackList,
            name: 'feedback-list',
            meta: {
                title: '反馈列表'
            }
        },
        {
            path: 'feedback-detail/:type/:id',
            component: FeedbackDetail,
            name: 'feedback-detail',
            meta: {
                title: '反馈详情',
                hidden: true
            }
        }
    ]
}
